const TitleWithLines = ({ title }: { title: string }) => {
  return (
    <div className="flex w-full gap-2 justify-center items-center flex-grow-0">
      <div className="flex h-0.5 w-[5%] bg-gray-100"></div>
      <p className="text-BodyText/14/Light text-gray-500">منوی اصلی</p>
      <div className="flex h-0.5 flex-grow bg-gray-100"></div>
    </div>
  );
};

export default TitleWithLines;
